import { StageDefinition } from './StageDefinition';

export const stage11: StageDefinition = {
    platforms: [
        [46.45161290322581, 0],
        [127.74193548387095, 0],
        [139.3548387096774, 0],
        [232.2580645161291, 0],
        [56.84210526315789, 1],
        [132.6315789473684, 1],
        [217.89473684210515, 1],
        [227.36842105263145, 1],
        [236.84210526315775, 1],
        [246.31578947368405, 1],
        [65.45454545454545, 2],
        [130.90909090909093, 2],
        [72.00000000000001, 3],
        [129.60000000000002, 3],
        [295.19999999999976, 3],
        [302.39999999999975, 3],
        [309.59999999999974, 3],
        [316.7999999999997, 3],
        [82.10526315789474, 4],
        [170.5263157894737, 4],
        [176.84210526315792, 4],
        [183.15789473684214, 4],
        [189.47368421052636, 4],
        [91.4285714285714, 5],
        [99.13043478260872, 6],
        [105.59999999999997, 7],
        [110.39999999999996, 7],
        [115.19999999999996, 7],
        [119.99999999999996, 7],
        [139.2, 7],
        [144, 7],
        [148.8, 7],
        [153.60000000000002, 7],
    ],
    traps: [],
    stars: [
        [81, 0],
        [95, 1],
        [111, 0],
        [56, 4],
        [80, 6],
        [112, 8],
        [131, 5],
        [147, 8],
        [179, 5],
        [171, 1],
        [196, 1],
        [231, 2],
        [304, 0],
        [307, 4],
    ],
};
